export { default } from './MarkdownRender';



// WEBPACK FOOTER //
// ./src/components/common/MarkdownRender/index.js